export default "__VITE_ASSET__17d6e12c__"